import { render, staticRenderFns } from "./lk-review.vue?vue&type=template&id=b7294ef8&"
import script from "./lk-review.vue?vue&type=script&lang=js&"
export * from "./lk-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-review.vue
// module id = 1400
// module chunks = 0